import { useCallback } from 'react'

import { useConfigsContext } from '@/context/ConfigsContext'
import { fetchUploadRoomImage } from '@/services/cms'

export const useUploadImage = () => {
  const { store } = useConfigsContext()
  const htcToken = store?.credentials?.htcToken

  const uploadImage = useCallback(
    async (file: File) => {
      if (!htcToken) {
        throw new Error('missing htcToken')
      }

      const response = await fetchUploadRoomImage(htcToken, file)

      if (response?.status === 200 && response?.results) {
        return response.results.url
      } else {
        throw new Error('Upload image failed')
      }
    },
    [htcToken],
  )

  return { uploadImage }
}
